// extracted by mini-css-extract-plugin
export default {"root":"dU7HRka","label":"fLdoQss"};